import mitt from 'mitt';

const emitter = mitt();

const EventBus = {
    $on: (...args) => emitter.on(...args),
    $off: (...args) => emitter.off(...args),
    $emit: (...args) => emitter.emit(...args),
    // True when at least one handler is registered for exactly this event name.
    // mitt keeps an (possibly empty) array per type after $off, so check length.
    $has: (event) => {
        const handlers = emitter.all.get(event);
        return Array.isArray(handlers) && handlers.length > 0;
    },
};

// Add $once alias
EventBus.$once = (event, fn) => {
    const handler = (...args) => {
        fn(...args);
        emitter.off(event, handler);
    };
    emitter.on(event, handler);
};

export default EventBus;